import React from 'react';

export const AppContext = React.createContext({
  platform: 'iOS',
  languages: [
    {
      label: 'Swift',
      value: 'swift'
    },
    {
      label: 'Objective C',
      value: 'objective-c'
    }
  ],
  preferredLanguage: 'swift'
});
